/**
 * ------------------------------------------------------------
 * Developer Name : Praveen Tripathi
 * Purpose        : Landing sticky enroll / download CTA chrome
 * ------------------------------------------------------------
 *
 * Owns EnrollNowStickyLp / DownloadCTASticky composition for MBA LP chrome.
 * Mirrors PrimaryLayoutTop sticky ownership in layout-primary.
 */

"use client";

import { usePathname } from "next/navigation";
import { resolveMbaPhoneHeader } from "../utils/resolveMbaPhoneHeader";
import { DownloadCTASticky, EnrollNowStickyLp } from "./landing-chrome-dynamic";

type LandingStickyChromeProps = {
  data: {
    headerFooterData?: {
      header?: { enabled?: boolean };
      webinar?: unknown;
      isCROPage?: boolean;
      headerMenu?: { associatedPrograms?: unknown[] };
    };
    slugs?: string[];
    device?: string;
  };
};

export default function LandingStickyChrome({ data }: LandingStickyChromeProps) {
  const headerFooterData = data?.headerFooterData || {};
  const { header, webinar, isCROPage } = headerFooterData;
  const isMobile = data?.device === "mobile";
  const pathName = usePathname();
  const slug = data?.slugs?.join("/") || "";
  const associatedPrograms =
    headerFooterData?.headerMenu?.associatedPrograms || [];

  if (!header?.enabled) return null;

  const { updatedheader, isPhoneNumber } = resolveMbaPhoneHeader(header, slug);
  const isWebinarPage = pathName.includes("-webinar");

  if (isCROPage && isMobile) {
    return <EnrollNowStickyLp associatedPrograms={associatedPrograms} />;
  }

  return (
    <DownloadCTASticky
      isPhoneNumber={isPhoneNumber}
      updatedheader={updatedheader}
      webinar={webinar}
      isWebinar={isWebinarPage}
      associatedPrograms={associatedPrograms}
    />
  );
}
